module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emp-img-table"
  }, [_c('img', {
    staticClass: "emp-img cursor-pointer",
    attrs: {
      "src": _vm.imageSrc,
      "height": "40"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('i', {
    staticClass: "fa fa-close close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Image Gallery")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  })])], 2)])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-268d6bf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsTableTemplate/imageGallery.vue
// module id = 3639
// module chunks = 1